import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import StatusBadge from "@/components/StatusBadge";

export default function AdminProducts() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("submitted");
  useEffect(() => { api.get("/admin/products").then((r) => setItems(r.data)).catch(()=>{}); }, []);
  const filtered = items.filter((p) => tab === "all" ? true : p.status === tab);
  return (
    <DashboardLayout title="Product review">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="product-tabs">
          <TabsTrigger value="submitted" data-testid="tab-submitted">Awaiting review</TabsTrigger>
          <TabsTrigger value="approved" data-testid="tab-approved">Approved</TabsTrigger>
          <TabsTrigger value="rejected" data-testid="tab-rejected">Rejected</TabsTrigger>
          <TabsTrigger value="all" data-testid="tab-all">All</TabsTrigger>
        </TabsList>
        <TabsContent value={tab} className="mt-6">
          <Card>
            <CardHeader><CardTitle className="font-heading tracking-tight">{filtered.length} product{filtered.length===1?"":"s"}</CardTitle></CardHeader>
            <CardContent>
              {filtered.length === 0 ? (
                <div className="py-10 text-center text-muted-foreground text-sm" data-testid="admin-products-empty">Nothing here.</div>
              ) : (
                <Table data-testid="admin-products-table">
                  <TableHeader><TableRow><TableHead>Product</TableHead><TableHead>Supplier</TableHead><TableHead>Category</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Action</TableHead></TableRow></TableHeader>
                  <TableBody>
                    {filtered.map((p) => (
                      <TableRow key={p.id} data-testid={`admin-product-${p.id}`}>
                        <TableCell className="font-medium text-secondary">{p.name}</TableCell>
                        <TableCell><div>{p.supplier?.company_name || p.supplier?.name || "—"}</div><div className="text-xs text-muted-foreground">{p.supplier?.email}</div></TableCell>
                        <TableCell>{p.category}</TableCell>
                        <TableCell><StatusBadge status={p.status} /></TableCell>
                        <TableCell className="text-right"><Link to={`/admin/products/${p.id}`}><Button size="sm" variant="outline" data-testid={`review-${p.id}`}>Review</Button></Link></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </DashboardLayout>
  );
}
